export type EntityRef =
  | EntityRef.UpcomingShow
  | EntityRef.LiveShow
  | EntityRef.Event
  | EntityRef.Promotion
  | EntityRef.Seller
  | EntityRef.Replay;

export namespace EntityRef {
  export interface UpcomingShow {
    type: 'upcomingShow';
    upcomingShowId: string;
  }

  export interface LiveShow {
    type: 'liveShow';
    liveStreamId: string;
  }

  export interface Replay {
    type: 'replay';
    liveStreamId: string;
  }

  export interface Event {
    type: 'event';
    eventId: string;
  }

  export interface Promotion {
    type: 'promotion';
    promotionId: string;
  }

  export interface Seller {
    type: 'seller';
    sellerId: string;
  }
}

type EntityRefOfType<T, S = EntityRef> = S extends { type: T } ? S : never;
type EntityRefSelector<R, KT extends string = EntityRef['type']> = {
  [K in KT]: (showRef: EntityRefOfType<K>) => R;
};
export function entityRefSelect<T>(
  showRef: EntityRef,
  selector: EntityRefSelector<T>,
): T;
export function entityRefSelect<T, SRT extends string>(
  showRef: EntityRefOfType<SRT>,
  selector: EntityRefSelector<T, SRT>,
): T;
export function entityRefSelect<T>(
  showRef: EntityRef,
  selector: Partial<EntityRefSelector<T>>,
): undefined | T;
export function entityRefSelect<T>(
  showRef: EntityRef,
  selector: Partial<EntityRefSelector<T>>,
): undefined | T {
  return selector[showRef.type]?.(showRef as any);
}
